export enum ErrorReason {
  NetworkConnection = 'networkConnection',
  AddPanelInternal = 'addPanelInternal',
  AddPanelInternalNoStatus = 'addPanelInternalNoStatus',
}
